import React, { useState, useEffect } from "react";
import { forwardRef } from "react";
import MaterialTable from "material-table";
import { Row, Col } from "react-bootstrap";
import makeStyles from "@mui/styles/makeStyles";
import Paper from "@mui/material/Paper";
import Checkbox from "@material-ui/core/Checkbox";
import { TablePagination } from "@material-ui/core";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import ArrowDownward from "@mui/icons-material/ArrowDownward";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import Clear from "@mui/icons-material/Clear";
import FilterList from "@mui/icons-material/FilterList";
import FirstPage from "@mui/icons-material/FirstPage";
import LastPage from "@mui/icons-material/LastPage";
import Search from "@mui/icons-material/Search";
import ViewColumn from "@mui/icons-material/ViewColumn";
import CheckRole from "../CheckRole.js";
import AADService from "../funcionesAuth.js";
import CircularProgress from "@mui/material/CircularProgress";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { DecryptData } from "../DatosEncriptados/EncryptedFunctions";
import PikachuComponent from "../Evaluaciones/newEvaluaciones/loadingComponent.js";
import AnimatedGifComponent from "../Evaluaciones/newEvaluaciones/AnimatedGifComponent.js";
import { useHistory } from "react-router-dom";
// import PercentIcon from "@mui/icons-material/Percent";
import { Button } from "@mui/material";
import { useLocation } from "react-router-dom";

const tableIcons = {
  //Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

function PendientesAnalista(params) {
  const location = useLocation();
  const history = useHistory();
  const limpiarSeleccion = () => {
    setSelected([]); // deseleccionas todo
    SetButtonEdit(false); // desactivas el botón Editar
    setButtonDelete(false); // desactivas el botón Eliminar
    setActivoEvaluar(null); // limpias activo evaluado
  };
  const handleIr = () => {
    limpiarSeleccion();
    params.cerrarOffcanvas();

    // Primero guardas el ID en algún sitio temporal
    const idSeleccionado = selected;
    const idActivo = activoEvaluar;

    // Limpias el localStorage para simular volver al home
    localStorage.setItem("idevaluacion", 0);
    localStorage.setItem("idactivo", 0);
    history.push("/menu");
    setTimeout(() => {
      localStorage.setItem("idevaluacion", idSeleccionado);
      localStorage.setItem("idactivo", idActivo);
      history.push("/EditarEvaluacion");
    }, 20); // pequeño delay de 100ms
  };
  //Establece estilos de componentes
  const useStyles = makeStyles((theme) => ({
    container: {
      maxHeight: "55vh",
      minHeight: "55vh",
    },
    root: {
      width: "100%",
    },
    pagination: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    switch: {
      paddingLeft: "1.5em",
    },
    inside: {
      backgroundColor: "white",
      width: "100%",
      //margintom: theme.spacing(2),
    },
    table: {
      minWidth: 750,
    },
    head: {
      backgroundColor: "#2c2a29",
      color: "white",
    },
    visuallyHidden: {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      top: 20,
      width: 1,
    },
    palette: {
      primary: {
        main: "#4caf50",
      },
      secondary: {
        main: "#ff9100",
      },
    },
  }));

  //Modifica temas predeterminados por Material-Table
  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2c2a29",
      },
      secondary: {
        main: "#ff9100",
      },
    },
  });

  const renderLoading = () => <PikachuComponent />;
  const classes = useStyles();
  const [loadingComponent, setLoadingComponent] = useState(false);
  const [selected, setSelected] = React.useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [ButtonEdit, SetButtonEdit] = React.useState(false);
  const [filter, setFilter] = useState(false);
  const [opcionesGenerales, setOpcionesGenerales] = React.useState([]);
  const AzureADService = new AADService();
  const token = AzureADService.getToken();
  const check = new CheckRole("/evaluaciones");
  const [activoEvaluar, setActivoEvaluar] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [currentRol, setCurrentRol] = useState(null);
  const [buttonDelete, setButtonDelete] = useState(false);
  const [selectedToDelete, setSelectedToDelete] = useState(null);
  const [bandeja, setFetchBandeja] = useState([]);

  const renderBoolIcon = (val) => {
    const lower = val?.toLowerCase();
    return lower === "si" ? (
      <CheckIcon style={{ color: "#4CAF50" }} /> // Verde más suave
    ) : lower === "no" ? (
      <ClearIcon style={{ color: "#F44336" }} /> // Rojo menos brillante
    ) : (
      val || "-"
    );
  };
  const normalizarPorcentaje = (val) => {
    if (val == null || isNaN(val)) return 0;
    return Math.max(0, Math.min(100, val * 100));
  };
  const colorPorcentaje = (percentage) => {
    const hue = Math.round((percentage / 100) * 120); // 0 → 120
    return `hsl(${hue}, 85%, 45%)`;
  };

  const renderPorcentajeFijo = (val) => {
    const porcentaje = normalizarPorcentaje(val);
    const color = colorPorcentaje(porcentaje);

    return (
      <>
        <span
          style={{
            color,
            fontWeight: "bold",
            marginRight: 4,
          }}
        >
          {porcentaje.toFixed(1)} %
        </span>
        {/* <PercentIcon style={{ color, fontSize: 20 }} /> */}
      </>
    );
  };

  const columns = [
    { title: "ID Eval.", field: "idevaluacion" },
    { title: "Alerta", field: "tipo_alerta" },
    {
      title: "Analista",
      field: "analista",
      render: (rowData) =>
        rowData.analista && rowData.analista.trim() !== ""
          ? rowData.analista
          : "Sin responsable",
    },
    { title: "ID Activo", field: "idactivo" },
    { title: "Aplicativo", field: "nombre" },
    { title: "Detalle", field: "elementos" },
    {
      field: "control",
      title: "Avance controles",
      render: (rowData) => renderPorcentajeFijo(rowData.control),
    },
    {
      field: "vulnerabilidad",
      title: "Vulnerabilidad",
      render: (rowData) => renderBoolIcon(rowData.vulnerabilidad),
    },
    {
      field: "efectos",
      title: "Efectos",
      render: (rowData) => renderPorcentajeFijo(rowData.efectos),
    },
    {
      field: "infraestructura",
      title: "Infraestructura",
      render: (rowData) => renderBoolIcon(rowData.vulnerabilidad),
    },
  ];

  useEffect(() => {
    const fetchUsuario = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
          "usuarios/menu/" +
          localStorage.getItem("usuario") +
          "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      const encryptedUser = await result.json();
      const decryptedUser = DecryptData(encryptedUser);
      let usuario = JSON.parse(decryptedUser);
      let opciones = usuario.map((user) => {
        return {
          opcion: user.url_opcion,
          permisos: user.permisos.split(";"),
        };
      });
      setOpcionesGenerales(opciones);
      var validity = check.checkPermits(opciones, "GET");

      if (validity) {
        // fetchdata(usuario[0].idrol);
        setCurrentRol(usuario[0].idrol);
      }
    };

    const fetchBandeja = async () => {
      setLoading(true);
      const result = await fetch(
        process.env.REACT_APP_API_URL +
          "evaluacion/nuevaevaluacion/bandeja/" +
          localStorage.getItem("idusuario") +
          "/" +
          localStorage.getItem("idcompania") +
          "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      if (result.status >= 200 && result.status <= 300) {
        let param = await result.json();
        const propiasOrdenadas = ordenarPorEvaluacionYTipo(
          param?.propias ?? []
        );
        const companiaOrdenadas = ordenarPorEvaluacionYTipo(
          param?.compania ?? []
        );
        const datosOrdenados = [...propiasOrdenadas, ...companiaOrdenadas];
        setFetchBandeja(datosOrdenados);
        setLoading(false);
      } else if (result.status >= 400 && result.status <= 500) {
        setFetchBandeja([]);
        return result.status;
      }
    };
    fetchUsuario();
    fetchBandeja();
  }, []);

  const handleClick = (id, idactivo) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat([], id);
      SetButtonEdit(true);
      setButtonDelete(true);
    } else {
      SetButtonEdit(false);
      setButtonDelete(false);
    }
    setSelected(newSelected);
    setActivoEvaluar(idactivo);
  };
  const editar = (event, props) => {
    localStorage.setItem("idevaluacion", selected);
    localStorage.setItem("idactivo", activoEvaluar);
    params.action();
  };

  //Habilita y desabilita los filtros por columnas
  const handleChange = () => {
    setFilter(!filter);
  };

  const prioridadTipoAlerta = (tipo = "") => {
    if (tipo === "Vulnerabilidades explotadas") return 0;
    if (tipo === "Vulnerabilidades con Exploit conocido") return 1;
    return 2; // resto
  };

  const ordenarPorEvaluacionYTipo = (items = []) => {
    return [...items].sort((a, b) => {
      // Asegura que las del mismo idevaluacion queden juntas
      const evalA = Number(a?.idevaluacion ?? Infinity);
      const evalB = Number(b?.idevaluacion ?? Infinity);

      if (evalA !== evalB) return evalA - evalB; // ascendente por idevaluacion

      // Dentro de la misma evaluación, por prioridad de tipo_alerta
      const pa = prioridadTipoAlerta(a?.tipo_alerta);
      const pb = prioridadTipoAlerta(b?.tipo_alerta);

      if (pa !== pb) return pa - pb;

      // (Opcional) más criterios de desempate dentro de la misma evaluación:
      // Por ejemplo, efectos descendente, fecha, nombre, etc.
      // const ea = Number(a?.efectos ?? -Infinity);
      // const eb = Number(b?.efectos ?? -Infinity);
      // if (ea !== eb) return eb - ea;

      // Último desempate por id (estable)
      return Number(a?.idalertas ?? 0) - Number(b?.idalertas ?? 0);
    });
  };

  return (
    <div className={classes.root}>
      <div>{loadingComponent && renderLoading()}</div>
      <div> {loadingComponent && <AnimatedGifComponent />}</div>
      <Row className="pl-3 pt-3 pb-3">
        <Col sm={8}>
          <h2 className="titulo" style={{ color: "black" }}>
            Alertas
          </h2>
        </Col>
      </Row>
      <Paper variant="outlined" className={classes.paper}>
        <MuiThemeProvider theme={theme}>
          <div style={{ overflowX: "auto" }}>
            <MaterialTable
              key={location.pathname}
              columns={columns}
              // {columns.map((column) => ({
              //   ...column,
              //   render: (rowData) => (
              //     <Tooltip title={rowData[column.field]}>
              //       <span>{rowData[column.field]}</span>
              //     </Tooltip>
              //   ),
              // }))}
              data={bandeja}
              icons={tableIcons}
              options={{
                rowStyle: (rowData) => ({
                  backgroundColor:
                    ButtonEdit === true && selectedRow === rowData.tableData.id
                      ? "#fff8d3"
                      : "#FFF",
                }),
                showTitle: false,
                filtering: filter,
                searchFieldAlignment: "left",
                headerStyle: {
                  backgroundColor: "#2c2a29",
                  color: "#ffffff",
                  position: "sticky",
                  top: 0,
                  fontFamily: "CIBFont Sans Regular",
                  fontWeight: 400,
                  fontSize: "1.2rem",
                  lineHeight: 1.6,
                  letterSpacing: "0.0075em",
                  flex: "1 1 100%",
                },
                maxBodyHeight: "520px",
                selection: false,
                disableMultipleSelection: true,
                pageSizeOptions: [10, 20, 30],
                showSelectAllCheckbox: false,
                showTextRowsSelected: false,
                pageSize: 10,
              }}
              components={{
                Pagination: (props) => (
                  <div className={classes.pagination}>
                    <FormControlLabel
                      className={classes.switch}
                      control={
                        <Checkbox
                          checked={filter}
                          onChange={handleChange}
                          inputProps={{ "aria-label": "primary checkbox" }}
                        />
                      }
                      label={
                        <Typography variant="body2">
                          Mostrar filtros por columnas
                        </Typography>
                      }
                    />
                    <TablePagination
                      {...props}
                      className={classes.pagination}
                    />
                  </div>
                ),
              }}
              onRowClick={(evt, selectedRow) => {
                handleClick(selectedRow.idevaluacion, selectedRow.idactivo);
                setSelectedToDelete(selectedRow);
                return setSelectedRow(selectedRow.tableData.id);
              }}
              actions={[
                loading
                  ? {
                      icon: () => <CircularProgress />,
                      position: "toolbar",
                      isFreeAction: true,
                    }
                  : {
                      icon: () => (
                        <Button
                          onClick={handleIr}
                          style={{
                            backgroundColor: "#a9a9a9",
                            color: "#fff",
                            borderRadius: "5px",
                            height: "40px",
                            minWidth: "100px",
                          }}
                        >
                          Ir
                        </Button>
                      ),
                      onClick: () => editar(),
                      position: "toolbar",
                      isFreeAction: true,
                      hidden: ButtonEdit === false,
                    },
              ]}
              localization={{
                toolbar: {
                  searchPlaceholder: "Buscar",
                },
                body: {
                  emptyDataSourceMessage: "No se encontraron registros",
                },
                pagination: {
                  labelRowsSelect: "Filas",
                  firstTooltip: "Primera página",
                  previousTooltip: "Anterior",
                  nextTooltip: "Siguiente",
                  lastTooltip: "Última página",
                },
              }}
            />
          </div>
        </MuiThemeProvider>
      </Paper>
    </div>
  );
}

export default PendientesAnalista;
